import { render, staticRenderFns } from "./EditVideoCategoryPage.vue?vue&type=template&id=0162e9ca&"
import script from "./EditVideoCategoryPage.vue?vue&type=script&lang=js&"
export * from "./EditVideoCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports